export enum EnumTpNf {
    ENTRADA = 0,
    SAIDA = 1
}